<template>
  <client-only>
    <div :class="['bottom-tips', addClass]">
      <!-- 针对【原神】的特殊处理 start-->
      <div
        v-if="isGameNameGenshin"
        :class="[isDesktop ? `genshin-desktop` : `genshin-mobile`]"
        :style="bomCardStyles"
      >
        <h2 :style="fontColor">
          {{ $t(`genshin.bottom_notice.title`) }}
        </h2>
        <p :style="fontColor">
          {{ $t(`genshin.bottom_notice.desc`) }}
        </p>
      </div>
      <!-- 针对【原神】的特殊处理 end-->
      <!-- 针对【lordsmobile】的特殊处理 start-->
      <template v-else-if="isGameNameLordsmobile">
        <LordsmobileTipsBottom />
      </template>
      <!-- 针对【lordsmobile】的特殊处理 end-->
      <!-- 大部分的CP的公共头部 start -->
      <div
        v-else
        :class="[
          'detailClass',
          isDesktop ? `${detailClass}-desktop` : `${detailClass}-mobile`,
        ]"
        :style="bomCardStyles"
      >
        <div class="title" :style="fontColor">
          {{ title }}
        </div>
        <div
          :class="['content', getGameContent.length <= 2 ? 'even-content' : '']"
        >
          <div
            class="card"
            v-for="(item, index) in getGameContent"
            :key="index"
          >
            <div class="pad">
              <MBIcon
                classNames="tip-icon"
                :name="item._icon"
                :size="iconSize"
                :color="fontColor.color"
              />
              <div class="info">
                <h2 :style="fontColor">
                  {{ item.title }}
                </h2>
                <p :style="fontColor">
                  {{ item.desc }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 大部分的CP的公共头部 end -->
    </div>
  </client-only>
</template>
<script>
  import MBIcon from '@/components/MBIcon'
  import LordsmobileTipsBottom from '../LordsmobileTipsBottom'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { gameDiscounts } from '@page_detail/config.js'
  import { mapState } from 'vuex'

  export default {
    mixins: [styleConfiguration],
    props: {
      // warn 目前只有MLBB的【PC端】使用当前参数、会有很长时间覆盖不到全部、
      // ! 至此 先通过传递参数方式进行样式重构
      addClass: {
        type: String,
        default: '',
      },
    },
    components: {
      MBIcon,
      LordsmobileTipsBottom,
    },
    data() {
      return {
        detailClass: 'detail-bottom-tips',
      }
    },
    computed: {
      ...mapState([
        'userInfo',
        'isDesktop',
        'isApp',
        'gameName',
        'isMobile',
        'region',
      ]),
      ...mapState('detail', ['detailBasicConfig']),
      ...mapState(['isRuStarMaker']),

      fontColor() {
        if (this.isDesktop) {
          return this.pcMouldTextColor.color
            ? this.pcMouldTextColor
            : this.mFontColor
        }
        return this.mFontColor
      },

      // 游戏名称为 【genshin】
      isGameNameGenshin() {
        return /genshin/g.test(this.gameName)
      },
      // 游戏名称为 【lordsmobile】
      isGameNameLordsmobile() {
        const gameNames = ['lordsmobile']
        return gameNames.includes(this.gameName) && this.isMobile
      },
      bomCardStyles() {
        if (this.isDesktop) {
          return null
        }
        return this.moduleBackColor
      },

      iconSize() {
        if (this.isDesktop) return 35
        if (this.isMobile) return 75
        return 75
      },
      title() {
        const { massage } = this.gameText()
        return massage.benefitsToUser || ''
      },
      getGameinformation() {
        const {
          type = 'game',
          massage: {
            quick_arrival = {},
            limited_time_discount = {},
            official_cooperation = {},
            flexible_payment = {},
          },
        } = this.gameText()

        const quickInfo = {
          title: quick_arrival.title || '',
          desc: quick_arrival.desc || '',
          _icon: 'icon-quick',
        }
        const limitedInfo = this.setLimitedInfo(limited_time_discount, type)

        const officialInfo = {
          title: official_cooperation.title || '',
          desc: official_cooperation.desc || '',
          _icon: 'icon-tplat',
        }

        const flexibleInfo = this.setFlexibleInfo(flexible_payment)

        return {
          quickInfo,
          limitedInfo,
          officialInfo,
          flexibleInfo,
        }
      },

      getGameContent() {
        const { quickInfo, limitedInfo, officialInfo, flexibleInfo } =
          this.getGameinformation
        let benefitsTextMaps = []

        if (this.gameName === 'mobile-legends') {
          benefitsTextMaps = [
            quickInfo,
            flexibleInfo,
            limitedInfo,
            officialInfo,
          ]
        } else if ([1, 3].includes(this.awardType)) {
          benefitsTextMaps = [limitedInfo, officialInfo, flexibleInfo]
        } else {
          benefitsTextMaps = [quickInfo, limitedInfo, officialInfo]
          if (this.gameName !== 'pubgm') {
            benefitsTextMaps.push(flexibleInfo)
          }
        }

        return benefitsTextMaps.filter((item) => item.title && item.desc)
      },
    },
    methods: {
      setLimitedInfo({ title = '', desc = '' }, type) {
        const gameList = Object.keys(gameDiscounts)
        const games = this.isRuStarMaker ? 'publicDetails' : this.gameName

        // 进行折扣的单独处理{discount}
        if (gameList.includes(this.gameName)) {
          return {
            title,
            desc: this.$t(`${games}.limited_time_discount.desc`, {
              discount: gameDiscounts[this.gameName],
            }),
            _icon: 'icon-discount',
          }
        }
        if (type === 'default') {
          return {
            title,
            desc: this.$t(`publicDetails.limited_time_discount.desc`, {
              discount: '5%',
            }),
            _icon: 'icon-discount',
          }
        }
        return {
          title,
          desc,
          _icon: 'icon-discount',
        }
      },

      setFlexibleInfo({ title = '', desc = '' }) {
        const defaultName = this.detailBasicConfig?.gameShowDetail?.showName

        desc = this.$t(`publicDetails.flexible_payment.desc`, {
          gameName: defaultName || this.gameName,
        })
        return {
          title,
          desc,
          _icon: 'icon-support',
        }
      },

      gameText() {
        return {
          type: 'default',
          massage: this.$t(`publicDetails`),
        }
      },
    },
  }
</script>
<style scoped lang="scss" src="./styles.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './styles_pc.scss';
  }
  @media (min-width: 768px) and (max-width: 1280px) {
    @import './styles_pc.scss';
  }
  @media (max-width: 1120px) {
    @import './1120.scss';
  }
</style>
